export const isDateInPast = (date: string) => {
  const todayDate = new Date().toISOString().slice(0, 10);

  const date1 = new Date(date);
  const date2 = new Date(todayDate);

  if (date1 < date2) {
    return true;
  } else if (date1 > date2) {
    return false;
  } else {
    return false;
  }
};
